import React from 'react';

const TrashIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon-wrap"
    viewBox="0 0 30 30"
    width="16px"
    height="16px"
  >
    <path
      fill="#677892"
      d="M25.3 5.6h-2.8V1.9c0-1-.8-1.9-1.9-1.9H9.4c-1 0-1.9.8-1.9 1.9v3.8H4.7c-1 0-1.9.8-1.9 1.9v1.9h24.4v-2c0-1-.9-1.9-1.9-1.9zm-14 0V3.8h7.5v1.9h-7.5zM4.7 28.1c0 1 .8 1.9 1.9 1.9h16.9c1 0 1.9-.8 1.9-1.9V11.3H4.7v16.8zm14.1-12.2c0-.5.4-.9.9-.9s.9.4.9.9v9.4c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-9.4zm-4.7 0c0-.5.4-.9.9-.9s.9.4.9.9v9.4c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-9.4zm-4.7 0c0-.5.4-.9.9-.9s.9.4.9.9v9.4c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-9.4z"
    />
  </svg>
);

export default TrashIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/TrashIcon.js